import script from "./DialogVideoInfoHK.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogVideoInfoHK.vue?vue&type=script&setup=true&lang=ts"

import "./DialogVideoInfoHK.vue?vue&type=style&index=0&id=39b0d387&lang=scss"
import "./DialogVideoInfoHK.vue?vue&type=style&index=1&id=39b0d387&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39b0d387"]])

export default __exports__